import { rest } from 'msw'

import { config } from '@percent/admin-dashboard/config'

export const relatedOrganisationsHandlers = [
  rest.get(`${config.urls.api}v1/admin/validation/related-organisations`, async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json([]))
  })
]
